import { useState } from 'react';
import { MdModeEdit } from 'react-icons/md';
import { Button, Icon } from '@nbirl/nbi-common-ui-libs';
import { FormikConfig } from 'formik';

import { useErrorToast } from '../../../../shared/hooks';
import { ApiError } from '../../../../shared/models';
import { useEditFolder } from '../queries';
import { FolderNameFormValue } from './folder-name-form';
import { FolderNameModal } from './folder-name-modal.component';

type EditFolderProps = {
  folderId: string;
  initialName?: string;
  onSuccess: () => void;
};

export const EditFolder = ({
  folderId,
  initialName,
  onSuccess,
}: EditFolderProps) => {
  const mutation = useEditFolder();
  const { showErrorToast } = useErrorToast();
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const handleClick = () => {
    setModalOpen(true);
  };

  const handleSubmit: FormikConfig<FolderNameFormValue>['onSubmit'] = async (
    values,
    formikHelpers
  ) => {
    const { name } = values;

    try {
      await mutation.mutateAsync({ name, folderId });
      setModalOpen(false);
      onSuccess();
    } catch (error) {
      if (error instanceof ApiError && error.code === '03001') {
        formikHelpers.setFieldError('name', error.message);
      } else {
        showErrorToast('Unable to edit folder. Please try again.');
      }
    }
  };

  return (
    <>
      <Button
        data-tip="Edit folder"
        aria-label="Edit folder"
        onClick={handleClick}
        variant="light-teal"
        disabled={mutation.isLoading}
        size="sm"
        onlyIcon
      >
        <Icon size="18" icon={<MdModeEdit />} />
      </Button>

      <FolderNameModal
        mode="edit"
        modalHeading="New Folder Name"
        onSubmit={handleSubmit}
        isOpen={isModalOpen}
        onModalClose={() => setModalOpen(false)}
        isLoading={mutation.isLoading}
        initialName={initialName}
      />
    </>
  );
};
